import { render, staticRenderFns } from "./PixForm.vue?vue&type=template&id=36e95cf0&scoped=true&"
import script from "./PixForm.vue?vue&type=script&lang=ts&"
export * from "./PixForm.vue?vue&type=script&lang=ts&"
import style0 from "./PixForm.vue?vue&type=style&index=0&id=36e95cf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e95cf0",
  null
  
)

export default component.exports